<template>
  <Faq v-bind="componentData" />
</template>

<script>
import * as Cycle from '@aon/cycle'
import { mapValues } from 'lodash'

export default {
  name: 'CycleFaqSitecore',
  components: {
    Faq: Cycle.CycleFaqSitecore
  },
  props: {
    fields: {
      type: Object
    }
  },
  computed: {
    componentData() {
      return {
        ...mapValues(this.fields, (item) => item.value ?? item)
      }
    }
  }
}
</script>
